export function placementKey(placement) {
    return `${placement.number}-${placement.dir}`;
}

export function cellsForPlacement(placement) {
    const cells = [];
    const word = String(placement?.word || "");
    for (let i = 0; i < word.length; i += 1) {
        const row = placement.dir === "across" ? placement.row : placement.row + i;
        const col = placement.dir === "across" ? placement.col + i : placement.col;
        cells.push({ row, col, letter: word[i] });
    }
    return cells;
}

export function placementsCovering(placements, row, col) {
    return (placements || []).filter((placement) =>
        cellsForPlacement(placement).some((cell) => cell.row === row && cell.col === col),
    );
}

export function normalizeGuess(value) {
    return String(value || "").toUpperCase().replace(/[^A-Z]/g, "");
}
